<template>
  <div class="post-content-data__quote">
    <div class="post-content-data__quote-highlight">
      <img :src="data.highlight" />
    </div>
    <div class="post-content-data__quote-text">
      <strong v-if="data.title">
        "{{data.title}}"
      </strong>
      <p v-if="data.credit">
        {{data.credit}}
      </p>
    </div>
  </div>
</template>

<style lang="scss">
.post-content-data__quote {
  display: flex;
  grid-column: 2 span;
}

.post-content-data__quote-highlight {
  position: relative;
  width: 100%;
  max-width: rem-calc(420);

  margin-right: rem-calc(35);

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;

    object-fit: cover;
    transform: translate(-50%, -50%);
  }
}

.post-content-data__quote-text {
  color: $turmeric;

  strong {
    display: block;
    margin: 0;

    font-size: rem-calc(22);
    font-family: $font-family--header;
    line-height: rem-calc(30);
  }

  p {
    margin-top: rem-calc(20);
    margin-bottom: 0;

    font-size: rem-calc(12);
  }
}
</style>

<script>
export default {
  props: ['data'],
};
</script>
